import {
  ContentfulMediaMentions,
  getContentfulMediaMentions,
} from 'api/contentful/getContentfulMediaMention'
import { SimpleFlowSignup } from 'components/simpleFlowSignup/SimpleFlowSignup'
import { GetStaticProps } from 'next'
import { getIntlProps } from 'utils/i18n/getIntlProps'

interface WillSignupPageStaticProps {
  mediaMentions: ContentfulMediaMentions
}
export default function WillSignupPage(props: WillSignupPageStaticProps) {
  return <SimpleFlowSignup mediaMentions={props.mediaMentions} flowDirective="WILL" />
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const mediaMentions = await getContentfulMediaMentions('global')
  if (!mediaMentions) throw Error('Could not fetch Media Mentions.')

  return {
    props: {
      ...(await getIntlProps(ctx, ['trust_lp', 'entrance', 'auth'])),
      mediaMentions,
    },
  }
}
